import type { ElementType, HTMLAttributes } from 'react';
import { Box, Text, theme, VisuallyHidden } from '@frameio/vapor';

type MetadataRowProps = {
  icon: ElementType;
  metadata: string;
  title: string;
  metadataAriaText?: string;
} & HTMLAttributes<HTMLDivElement>;

export function MetadataRow({
  icon: Icon,
  metadata,
  title,
  metadataAriaText,
  ...other
}: MetadataRowProps) {
  return (
    <Box
      alignItems="center"
      data-testid={other?.['data-testid']}
      display="flex"
      justifyContent="space-between"
      width="100%"
    >
      <Box alignItems="center" display="flex" justifyContent="center">
        <Icon
          aria-hidden={true}
          color={theme.colors.icon.primary}
          size={16}
          style={{ marginRight: theme.spaces[8] }}
        />
        <Text color="tertiary" variant="secondary">
          {title}
        </Text>
      </Box>
      <span>
        {metadataAriaText && (
          <VisuallyHidden>{metadataAriaText}</VisuallyHidden>
        )}
        <Text
          aria-hidden={!!metadataAriaText}
          color="tertiary"
          variant="secondary"
        >
          {metadata}
        </Text>
      </span>
    </Box>
  );
}
